export const errorMessages = {
    "Claim not found" : "Claim Number entered does not find a match",
    "Date of loss provided does not match claim" : "Date of Loss entered does not find a match",
    "Name provided is not a Named Insured participant on the claim" : "Name entered does not find a match",
    "Logged on user is not a participant on the claim" : "The claim is unable to be viewed. Please contact the claim handler",
    "Claim includes participant in public adjuster role" : "This claim is unable to be viewed. Please contact the claim handler",
    "Error retrieving claim(s)" : "Something has gone wrong, we apologize for the inconvenience. Please try again later or contact the claim handler"
    
}